/* @flow weak */

import React from "react";

import createReactClass from "create-react-class";
import Reflux from "reflux";
import _ from "lodash";
import { IntlRootMixin } from "../IntlRootMixin";

import { Store } from "./Store";

const stores: { [name: string]: any } = {};

export const registerStore = function (name: string, store: Store) {
    stores[name] = store;
};

const actions: { [name: string]: any } = {};

export const registerActions = function (name: string, actionObject: any) {
    actions[name] = actionObject;
};

function handleStore(handler: any, store: any, props: any) {
    if (_.isFunction(handler)) {
        return handler(store, props);
    } else if (_.isArray(handler) && _.isFunction(store.getInitialState)) {
        return _.pick(store.getInitialState(), handler);
    } else {
        return {};
    }
}

function handleActions(handler: any, actionObject: any) {
    if (_.isArray(handler)) {
        return _.pick(actionObject, handler);
    } else {
        return {};
    }
}

function checkSpec(spec: any) {
    const errors = [];

    const knownOptions = ["stores", "actions"];
    const unknownOptions = _.difference(_.keys(spec), knownOptions);
    if (unknownOptions.length > 0) {
        errors.push(`unknown options: ${unknownOptions.join(", ")}`);
    }

    _.forEach(spec.stores, ([store, handler]) => {
        if (!store || !(store instanceof Store || typeof store.listen === "function")) {
            errors.push(`not a store: ${store}`);
        }
        if (!_.isFunction(handler) && !_.isArray(handler)) {
            errors.push(`bad handler: ${handler}`);
        }
    });

    _.forEach(spec.actions, ([actions, handler]) => {
        if (!actions) {
            errors.push(`actions null: ${actions}`);
        }
        if (!_.isArray(handler)) {
            errors.push(`bad actions handler: ${handler}`);
        }
    });

    if (errors.length > 0) {
        console.log("Bad connect spec:", errors);
        throw new Error("Bad connect spec: " + errors.join("\n"));
    }
}

type Spec<Props> = {
    stores?: Array<[Store, ((store: any, props: Props) => Partial<Props>) | string[]]>;
    actions?: Array<[any, any]>;
};

export const connect = function <Props>(
    spec: Spec<Props>,
    Component: React.ComponentType<Props>,
    addIntlRoot?: boolean,
    overrideDisplayName?: string
): React.ComponentType<Partial<Props>> & { WrappedComponent: React.ComponentType<Props> } {
    checkSpec(spec);

    const displayName = Component.displayName || (typeof Component === "function" ? Component.name : "");
    const addedMixins = [Reflux.ListenerMixin];
    if (addIntlRoot) {
        addedMixins.push(IntlRootMixin);
    }

    const Wrapper = createReactClass({
        mixins: addedMixins,

        displayName: overrideDisplayName ?? displayName + "Wrapper",

        componentWillMount() {
            _.forEach(spec.stores || [], ([store]) => {
                this.listenTo(store, () => {
                    // We just get the data directly from the stores without
                    // saving it in state, so here we just do a forceUpdate. If
                    // we want to do something more advanced here, it would be
                    // easy to switch though.
                    this.forceUpdate();
                });
            });
        },

        render() {
            let props = _.reduce(
                spec.stores,
                (result, [store, handler]) => {
                    return _.defaults(result, handleStore(handler, store, this.props));
                },
                _.clone(this.props)
            );
            props = _.reduce(
                spec.actions,
                (result, [actions, handler]) => {
                    return _.defaults(result, handleActions(handler, actions));
                },
                props
            );
            return <Component {...props} />;
        }
    });

    (Wrapper as any).WrappedComponent = Component;
    return Wrapper as any;
};
